import React, { useState } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const Contact = () => {
  const [formData, setFormData] = useState({
    name: '', company: '', phone: '', email: '', event_date: '', location: '', requirement: ''
  });
  const [status, setStatus] = useState('idle');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      await axios.post(`${BACKEND_URL}/api/inquiry`, formData);
      setStatus('success');
      setFormData({ name: '', company: '', phone: '', email: '', event_date: '', location: '', requirement: '' });
    } catch (err) {
      setStatus('error');
    }
  };

  return (
    <section id="contact" className="py-32 bg-accent text-primary relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-20">
        
        <div>
          <div className="text-xs uppercase tracking-[0.3em] mb-6 font-medium text-primary/60">Chapter 05 — Get in Touch</div>
          <h2 className="text-5xl md:text-7xl font-editorial mb-8 leading-none">
            Partner With <br/><span className="italic">Nirvaana</span>
          </h2>
          <p className="text-lg font-light mb-12 max-w-md">
            Let&apos;s discuss how our precision and hospitality can make your next event flawless.
          </p>
          
          <div className="space-y-6 font-light">
            <div>
              <p className="text-xs uppercase tracking-widest text-primary/50 mb-1">Email</p>
              <a href="mailto:events.nirvaana@gmail.com" className="text-xl hover:italic transition-all">events.nirvaana@gmail.com</a>
            </div>
            <div>
              <p className="text-xs uppercase tracking-widest text-primary/50 mb-1">Phone / WhatsApp</p>
              <a href="https://wa.me/916350282720" target="_blank" rel="noreferrer" className="text-xl hover:italic transition-all">+91 6350 282 720</a>
            </div>
            <div>
              <p className="text-xs uppercase tracking-widest text-primary/50 mb-1">Location</p>
              <p className="text-xl">Jagatpura, Jaipur, India</p>
            </div>
          </div>
        </div>

        <div className="bg-white p-10 md:p-14 rounded-sm">
          {status === 'success' ? (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="h-full flex flex-col items-center justify-center text-center py-20">
              <div className="w-16 h-16 rounded-full bg-secondary/10 text-secondary flex items-center justify-center mb-6">✓</div>
              <h3 className="text-3xl font-editorial mb-4">Proposal Requested</h3>
              <p className="font-light text-foreground/70">Thank you. Our team will reach out to you within 24 hours.</p>
            </motion.div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-xs uppercase tracking-widest text-foreground/60">Name*</label>
                  <input required className="w-full bg-transparent border-b border-border py-3 focus:outline-none focus:border-secondary transition-colors rounded-none" value={formData.name} onChange={e=>setFormData({...formData, name: e.target.value})} />
                </div>
                <div className="space-y-2">
                  <label className="text-xs uppercase tracking-widest text-foreground/60">Company</label>
                  <input className="w-full bg-transparent border-b border-border py-3 focus:outline-none focus:border-secondary transition-colors rounded-none" value={formData.company} onChange={e=>setFormData({...formData, company: e.target.value})} />
                </div>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-xs uppercase tracking-widest text-foreground/60">Email*</label>
                  <input type="email" required className="w-full bg-transparent border-b border-border py-3 focus:outline-none focus:border-secondary transition-colors rounded-none" value={formData.email} onChange={e=>setFormData({...formData, email: e.target.value})} />
                </div>
                <div className="space-y-2">
                  <label className="text-xs uppercase tracking-widest text-foreground/60">Phone*</label>
                  <input required className="w-full bg-transparent border-b border-border py-3 focus:outline-none focus:border-secondary transition-colors rounded-none" value={formData.phone} onChange={e=>setFormData({...formData, phone: e.target.value})} />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-xs uppercase tracking-widest text-foreground/60">Event Date</label>
                  <input type="text" placeholder="e.g. Nov 2026" className="w-full bg-transparent border-b border-border py-3 focus:outline-none focus:border-secondary transition-colors rounded-none" value={formData.event_date} onChange={e=>setFormData({...formData, event_date: e.target.value})} />
                </div>
                <div className="space-y-2">
                  <label className="text-xs uppercase tracking-widest text-foreground/60">Location</label>
                  <input placeholder="e.g. Jaipur" className="w-full bg-transparent border-b border-border py-3 focus:outline-none focus:border-secondary transition-colors rounded-none" value={formData.location} onChange={e=>setFormData({...formData, location: e.target.value})} />
                </div>
              </div>

              <div className="space-y-2">
                <label className="text-xs uppercase tracking-widest text-foreground/60">Your Requirement*</label>
                <textarea required rows={4} className="w-full bg-transparent border-b border-border py-3 focus:outline-none focus:border-secondary transition-colors resize-none rounded-none" value={formData.requirement} onChange={e=>setFormData({...formData, requirement: e.target.value})} />
              </div>

              <button 
                type="submit" 
                disabled={status === 'submitting'}
                className="w-full bg-primary text-white py-4 mt-8 uppercase text-xs tracking-[0.2em] hover:bg-secondary transition-colors disabled:opacity-50"
              >
                {status === 'submitting' ? 'Submitting...' : 'Submit Request'}
              </button>
              
              {status === 'error' && <p className="text-red-500 text-sm mt-4 text-center">Something went wrong. Please try again.</p>}
            </form>
          )}
        </div>
      </div>
    </section>
  );
};
